import { defineComponent } from 'vue'
import scrollbarConfig from '../config/scrollbar'

export default defineComponent({
    name: 'WithCustomScrollbar',
    created() {
        scrollbarConfig.updateCSSVariables()
    },
})
